<template>
  <div data-test="notifiche-elenco">
    <SkeletonRegion v-if="caricamentoIniziale" class="flex flex-col gap-2"><SkeletonBlock v-for="n in 3" :key="n" height="3.75rem" radius="xl" /></SkeletonRegion>
    <ErrorState v-else-if="errore && !righe" :description="t('centro_notifiche.errore')" :retrying="ritentando" @retry="emit('ritenta')" />
    <EmptyState v-else-if="!gruppi.length" icon="fal fa-bell-slash" :description="t(`centro_notifiche.vuoto.${filtro}`)" data-test="notifiche-vuoto" />
    <div v-else class="flex flex-col gap-3">
      <section v-for="g in gruppi" :key="g.chiave" :aria-label="g.etichetta" class="flex flex-col gap-1.5" data-test="notifiche-gruppo">
        <h3 class="px-1 text-xs font-semibold tracking-wide text-text-accent uppercase">{{ g.etichetta }}</h3>
        <ul class="flex flex-col gap-1.5">
          <NotificheRiga v-for="n in g.righe" :key="n.id" :notifica="n" :adesso="adesso" :mostra-testo="mostraTesto" @letta="(id) => emit('letta', id)" @archivia="(id, archiviare) => emit('archivia', id, archiviare)" @apri="(notifica) => emit('apri', notifica)" />
        </ul>
      </section>
      <p v-if="errore" class="px-1 text-xs text-text-muted" role="status">{{ t("centro_notifiche.non_aggiornato") }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
// Elenco delle notifiche raggruppate per giorno, con skeleton, errore e stato vuoto. Non carica nulla: chi lo usa (tendina, pagina) gli passa le righe già lette.
import { useI18n } from "vue-i18n";
import type { FiltroNotifiche, NotificaApi } from "~~/shared/data-model/notifica_api";
import { raggruppaPerGiorno } from "~/utils/notifiche";

const props = defineProps<{
  righe: readonly NotificaApi[] | null;
  filtro: FiltroNotifiche;
  caricamentoIniziale: boolean;
  errore: boolean;
  ritentando: boolean;
  adesso: Date;
  mostraTesto?: boolean;
}>();
const emit = defineEmits<{ letta: [id: number]; archivia: [id: number, archiviare: boolean]; apri: [notifica: NotificaApi]; ritenta: [] }>();

const { t, locale } = useI18n();
const gruppi = computed(() => raggruppaPerGiorno(props.righe ?? [], props.adesso, locale.value, { oggi: t("centro_notifiche.gruppi.oggi"), ieri: t("centro_notifiche.gruppi.ieri") }));
</script>
